<template>
  <div id="cart-wap">
    <!-- <div class="date-style">{{ content.publishTime }}</div> -->
    <div class="cart" v-if="!content.images.length">
      <div class="header">
        <span class="title">{{ content.title }}</span>
      </div>
      <div class="content">
        {{ content.desc }}
      </div>
      <div class="footer">
        <a style="color: #1989fa">详情</a>
      </div>
    </div>

    <div class="cart-up" v-else>
      <div class="left">
        <h1>{{ content.title }}</h1>
        <p>{{ content.publishTime }}</p>
      </div>
      <!-- <div class="right" :style="{background:'url('+content.images+')'}"> -->
      <div class="right">
        <img :src="content.images" alt="" />
      </div>
      <!-- <div class="header">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(path, index) in content.images" :key="index"><img :src="path" alt=""></van-swipe-item>
        </van-swipe>
      </div>
      <div class="content">
        <span class="title">{{content.title}}</span>
        <span class="desc">{{content.desc}}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  props: {
    layout: {
      type: String,
    },
    content: {
      type: Object,
    },
  },
  data() {
    return {
      time: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
    };
  },
  methods: {},
};
</script>

<style lang="less">
#cart-wap {
  .date-style {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
  }
  // .cart-common {
  //   margin-bottom: 20px;
  //   text-align: left;
  //   padding: 5px;
  //   border: 1px solid #eee;
  //   background-color: #fff;
  //   border-radius: 5px;
  // }
  .cart {
    .header {
      padding: 5px;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #333;
      }
    }
    .content {
      padding: 10px 10px 15px 10px;
      border-bottom: 1px solid #eee;
      font-size: 15px;
    }
    .footer {
      padding: 5px;
    }
  }
  .cart-up {
    background: #f4f8fd;
    border-radius: 10px;
    padding: 16px 24px;
    display: flex;
    margin-bottom: 16px;
    .right {
      width: 102px;
      min-width: 102px;
      height: 68px;
      overflow: hidden;
      border-radius: 6px;
      margin-left: 24px;
      position: relative;
      img {
        border-radius: 6px;
        position: absolute;
        height: 68px;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        -webkit-transform: translate3d(-50%, -50%, 0);
      }
    }
    .left {
      h1 {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2f354d;
        line-height: 20px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 4px;
      }
      p {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9095a7;
        line-height: 16px;
        margin-top: 4px;
      }
    }
    .header {
      .my-swipe {
        width: 100%;
        max-height: 188px;
        overflow: hidden;
        border-radius: 5px 5px 0 0;
        img {
          width: 100%;
          // max-height: 188px;
          border-radius: 5px 5px 0 0;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      padding: 12px 10px;
      .title {
        font-size: 17px;
        font-weight: 400;
        color: #333;
        margin-bottom: 3px;
      }
      .desc {
        font-size: 14px;
        color: #aaa;
      }
    }
  }
}
</style>
